import logger from 'utils/logger.util';

const L = logger('EVENT');

export const fromEventToName = (event) => {
  if (!event) L.warn('Invalid event:', event);
  return event?.target?.name ?? void 1;
};

export const fromEventToTarget = (event) => {
  if (!event) L.warn('Invalid event:', event);
  return event?.target ?? void 1;
};

export const fromEventToValue = (event) => {
  if (!event) L.warn('Invalid event:', event);

  const target = event?.target;
  const type = target?.type;

  return ('checkbox' === type ? target?.checked : target?.value) ?? void 1;
};
